<template lang="pug">
v-card.creat-video-list-item.dragItem.add-card.d-flex.justify-center.align-center(v-else @click="chooseAsActive" elevation="0" height="100" :width="this.$vuetify.breakpoint.xs ? '90%' : 100"
)
  v-row.fill-height.ma-0(:style="{backgroundColor: selectedTheme ? selectedTheme.primaryColor : 'grey', borderColor: selectedTheme ? selectedTheme.primaryColor : 'grey'}" align="center", justify="center")
    h3.text-uppercase.white--text.text-center {{video.title}}
    //- v-row.play-overlay.fill-height.ma-0()
      v-menu.py-0(top='' v-model="moreMenu" content-class="elevation-25" offset-y offset-x :close-on-click='true')
        template(v-slot:activator='{ on, attrs }')
          v-btn.menuBtn(color='primary' x-small dark='' text v-bind='attrs' v-on='on')
            v-icon.white--text(small) fa fa-ellipsis-h
        v-list.py-0(dense)
          v-list-item(@click="removeItem")
            v-list-item-icon.mr-2
              v-icon(small) delete
            v-list-item-title {{$t('create.remove')}}

</template>
<script>
import { mapState } from "vuex";
import urlFormat from "@/utils/urlFormat";
export default {
  name: "TimelineThemeItem",
  props: ["video"],
  data() {
    return {
      fab: false,
      moreMenu: false,
    };
  },
  computed: {
    ...mapState({
      selectedTheme: (state) => state.create.selectedTheme,
    }),
  },
  methods: {
    ...urlFormat,
    async chooseAsActive() {
      let video = {
        ...this.video,
        url:
          this.video.id == "intro"
            ? this.selectedTheme.intro
            : this.selectedTheme.outro,
      };
      this.$parent.$emit("clicked", video);
    },
    removeItem() {
      this.$store.commit("create/remove_element_from_timeline", this.video);
    },
  },
};
</script>
<style lang="sass" scoped>
@import '@/assets/style/main'

.play-overlay
  background: rgba(0,0,0,0.2)
  position: absolute
  top: 0
  bottom: 0
  right: 0
  left: 0
  cursor: pointer
  transition: $transition

  opacity: 0
  &.active
    border: 1px solid $accent
    opacity: 1
  &:hover
    opacity: 1

  .menuBtn
    height: 12px
    min-width: 20px
    padding: 4px
    position: absolute
    right: 8px
    top: 8px
    &:hover
      background-color: $accent
.dragItem
  // transform: scale(0.95)
  margin: 0 6px
  transition: all 0.4s ease
  &::before
    opacity: 0 !important
.creat-video-list-item
  border-radius: 12px
  width: 100%
  min-width: 100px !important
  overflow: hidden
  position: relative
  background: $primary

  @media only screen and (max-width: 600px)
    margin: 10px auto !important
  .absolute
    position: absolute
    position: relative
    top: 10px
    right: 5px
    align-content: center
    margin: 0
    padding: 0
  &.active


    border: 1px solid $accent
  &:hover
    .addVideoArea
      background: rgba(255,255,255, 0.1)
      transition: all .35s ease-in-out
      .v-icon
        opacity: 0.6
        transition: all .35s ease-in-out
      &:hover
        background: rgba(255,255,255, 0.6)
        .v-icon
          opacity: 1
</style>
